import * as React from 'react';
import styled from 'styled-components';
import { string } from 'prop-types';
const StyledCurrency = styled.span.attrs(() => ({
  className: 'currency'
})).withConfig({
  displayName: "Currency__StyledCurrency",
  componentId: "sc-1jdgn94-0"
})([""]);
const Currency = ({
  currencyCode
}) => /*#__PURE__*/React.createElement(StyledCurrency, null, I18n.t(`shared.currencies.${currencyCode}`));
Currency.propTypes = {
  /** Код валюты */currencyCode: string
};
export default Currency;